import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className, testid }) => (
  <motion.div
    data-testid={testid}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export default Reveal;
